import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import Title from 'components/ui/Title';

import { linkWithUnderlineHover } from 'styles/mixins';
import { css } from '@emotion/react';

import { breakpoints } from 'styles/basic';

interface AwardProps {
  type?: string | undefined;
}

const Wrapper = styled.div`
  display: block;
  width: 100%;
`;

const StyledTitle = styled(Title)`
  margin-left: .5rem;
`;

const AwardsTableSection = styled.section`

`;

const AwardsTable = styled.div`
  table {
    width: 100%;
    td, th {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 1rem;
      width: 100%;
      border: none;
    }
    thead {
      display: none;
      td {
        background: ${(props) => props.theme.color.lightGray};
        color: ${(props) => props.theme.color.darkGray};

        &:first-of-type {
          border-top-left-radius: .5rem;
        }
        &:last-of-type {
          border-top-right-radius: .5rem;
        }
      }
    }
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    table {
      width: 100%;
      td, th {
        display: table-cell;
      }
      td + td {
        border-left: .3rem solid ${(props) => props.theme.color.lightGray};
      }
      tr + tr {
        td {
          border-top: .3rem solid ${(props) => props.theme.color.lightGray};
        }
      }
      td {
        width: calc((100% - 35% - 20%) / 2);
        padding: 1rem;
        &:nth-of-type(1) {
          width: 35%;
        }
        &:nth-last-of-type(1) {
          width: 20%;
        }
      }
      thead {
        display: table-header-group;
      }
      tbody {
        td:first-of-type {
          font-weight: bold;
        }
      }
    }
  }
`;

const AwardWrapper = styled.span<AwardProps>`
  display: flex;
  align-items: center;
  gap: .5rem;
  font-size: 1.6rem;
  text-transform: uppercase;

  svg {
    flex-shrink: 0;
    font-size: 2rem;
  }

  ${(props) => props.type === 'nominated' && css`
    color: ${props.theme.color.darkGray};
  `};
  ${(props) => props.type === 'won' && css`
    color: #f2c511;
  `};
`;

const AwardLink = styled(Link)`
  ${(props) => linkWithUnderlineHover('&', 2, props.theme.mainColors.primary)};
`;

const TheadTitle = styled.div`
  display: block;
  padding: .3rem .5rem;
  border-radius: .3rem;
  background: ${(props) => props.theme.color.lightGray};
  color: ${(props) => props.theme.color.darkGray};

  @media (min-width: ${breakpoints.portraitTablet}) {
    display: none;
  }
`;

export {
  Wrapper,
  StyledTitle,
  AwardsTableSection,
  AwardsTable,
  AwardWrapper,
  AwardLink,
  TheadTitle
};
